import * as colors from './colors'
import * as backgroundColors from './backgroundColors'
import { typography } from '.'

export default {
  switch: {
    trackColor: {
      false: backgroundColors.white,
      true: backgroundColors.srDarkGreen
    }
  },
  slider: {
    minimumTrackTintColor: colors.srDarkGreen,
    maximumTrackTintColor: colors.subtle,
  },
  tabSelector: {
    container: {
      backgroundColor: colors.white,
      borderColor: colors.srGreen,
    },
    activeTab: {
      backgroundColor: colors.srDarkGreen,
    },
    separator: {
      backgroundColor: colors.srGreen,
    }
  },
  horizontalLineSpacer: {
    backgroundColor: colors.srGreen
  },
  plans: {
    container: {
      backgroundColor: backgroundColors.white
    },
    title: {
      color: colors.srPlaceholder
    },
  },
  planItem: {
    label: { color: colors.srDarkGreen },
    value: { color: colors.srDarkGreen },
    unit: { color: colors.srDarkGreen },
    duration: { color: colors.srDarkGreen },
    price: { color: colors.srDarkGreen },
  },
  navigationHeader: {
    color: colors.brightOrange,
    flex:1,
    ...typography.extrabold,
    fontSize: 22,
    textAlign: 'center'
  },
  navigationHeaderProcessing: {
    color: colors.brightOrange,
    flex:1,
    textAlign:'center',
    ...typography.extrabold,
    fontSize: 22
  },
  navigationHeaderLong: {
    color: colors.brightOrange,
    flex:1,
    textAlign:'center',
    ...typography.extrabold,
    fontSize: 18
  },
  navigationItemHeader: {
    color: colors.darkCharcoal,
    textAlign: 'center',
    ...typography.bold,
    fontSize: 16,
  },
  navigationHeaderSwitchNumber: {
    color: colors.white,
    flex:1,
    textAlign:'center',
    ...typography.extrabold,
    fontSize: 22
  },
  navigationHeaderPlan: {
    color: colors.brightOrange,
    flex:1,
    textAlign:'center',
    ...typography.lightbold,
    fontSize: 22
  },
  navigationHeaderUpdateReciept: {
    color: colors.brightOrange,
    flex:1,
    textAlign:'center',
    ...typography.extrabold,
    fontSize: 20
  },
}
